module.exports = __webpack_public_path__ + "static/media/blog-christmas-featured-square@2x.2fccd16c.jpg";